import { formatText } from "@eusoft/webapp-ui/utils/Format";
import { executeAsync, executeCacheAsync } from "./DataService";
import { selectContextAsync } from "../actions";
import type { IEntityView, ISaleCircuitListView, ISaleCircuitOptions, ISalePointListView, SalePointType } from "../entities/Commands";

interface IContext {

    salePoint: IEntityView;

    saleCircuit?: IEntityView;

    merchant?: IEntityView;

    operator?: IEntityView;
}

export type ContextEntityType = "sale-point" | "sale-circuit" | "merchant" | "operator";

export type ContextEntityFeature = SalePointType;

class Context implements IContext {

    protected _saleCircuitList: ISaleCircuitListView[];

    constructor() {

        this.load();
    }

    async refreshAsync() {

        this._saleCircuitList = (await executeCacheAsync("ListSaleCircuit", {
            includeSalePoints: true,
            includeMerchants: true
        })).items;

        for (const sc of this._saleCircuitList) {
            if (!sc.salePoints || !sc.merchants)
                continue;
            for (const sp of sc.salePoints) {
                const spMerch = sc.merchants.find(a => a.merchant?.id == sp.merchant.id);
                sp.merchant.name = spMerch.merchant.name;
            }
        }
    }

    async ensureSalePointAsync(feature?: ContextEntityFeature) {

        if (!this.salePoint || (feature && this.salePoint.type != feature)) {

            return (await selectContextAsync({
                type: "sale-point",
                feature
            })) as boolean;
        }

        return true;
    }

    async ensureSaleCircuitAsync() {

        if (!this.saleCircuit) {

            return (await selectContextAsync({
                type: "sale-circuit",
            })) as boolean;
        }

        return true;
    }

    async ensureMerchantAsync() {

        if (!this.merchant) {

            return (await selectContextAsync({
                type: "merchant",
            })) as boolean;
        }

        return true;
    }

    protected load() {

        const json = localStorage.getItem("pm.context");
        if (json) {
            Object.assign(this, JSON.parse(json));
        }
    }

    async updateOptionsAsync() {

        if (!this.saleCircuit)
            this.options = null;
        else
            this.options = await executeAsync("GetSaleCircuitOptions", { id: this.saleCircuit?.id });
    }

    save() {

        const obj = {
            salePoint: this.salePoint,
            saleCircuit: this.saleCircuit,
            merchant: this.merchant,
            operator: this.operator
        } as IContext;

        localStorage.setItem("pm.context", JSON.stringify(obj));
    }

    get saleCircutList() {
        return this._saleCircuitList;
    }

    get salePointName() {

        if (!this.salePoint?.id)
            return;
        return formatText("item-with-info", this.salePoint.name, this.merchant?.name);
    }

    salePoint: ISalePointListView;

    saleCircuit?: ISaleCircuitListView;

    merchant?: IEntityView;

    operator?: IEntityView;

    options?: ISaleCircuitOptions;

}


export const context = new Context();